import React from "react";
import { parseName, parsePath } from "~/utils/parsers";
import { posthogEventResourceGroupSelected } from "~/utils/posthog/resources";
import { groupResourcesByTimeSince } from "./utils";
import Card from "~/components/parts/Card";

const RecentlyAdded = ({ latestResources }) => (
  <Card
    className="m-0 mb-4 border-[#c1b420] xl:mx-1"
    title="Recently Published"
  >
    <div className="flex flex-col gap-4">
      {groupResourcesByTimeSince(latestResources).map(
        ({ dateString, resources }) => (
          <div key={`resources-${dateString}`} className="flex flex-col">
            <span className="mb-2 ml-1 text-xs font-bold uppercase text-slate-500">{`${dateString}`}</span>
            {resources.map(({ path, rid, title, topic }) => {
              const href = `/downloadables.php?rid=${rid}`;
              const handleClick = (e) => {
                e.preventDefault();
                posthogEventResourceGroupSelected({
                  triggerId: "downloadables-recently-published-item",
                  groupType: "resource",
                  resource: { rid, title },
                });
                window.location = href;
              }
              return (
                <a
                  key={`resource-${rid}`}
                  className="group mb-2 flex flex-col gap-1 rounded border border-slate-200 bg-[#fdfdfe] p-2 shadow-sm transition hover:border-slate-300 hover:bg-white"
                  href={href}
                  onClick={handleClick}
                >
                  <span className="block text-2xs text-slate-400 xl:text-xs">
                    {parsePath(path, topic)}
                  </span>
                  <span className="block pt-1 text-sm font-bold text-slate-600 transition group-hover:text-slate-900">
                    {parseName(title)}
                  </span>
                </a>
              );
            })}
          </div>
        ),
      )}
    </div>
  </Card>
);

export default RecentlyAdded;
